<app-tenant-groups-table
  [dataSource]="dataSource"
  (onItemAction)="onItemAction($event)"
></app-tenant-groups-table>
